;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputTextArea', inputTextArea)

  /* @ngInject */
  function inputTextArea () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        rows: '@',
        modelPropertyName: '@',
        model: '=',
        value: '<',
        disabled: '<',
        change: '=',
        placeholder: '@'
      },
      templateUrl: '/core/directives/input-text-area/input-text-area-directive.html?$$REVISION$$',
      controller: 'InputTextAreaController'
    }
  }
})()
